<template>
    <div class="travel-notes-list">
        <section class="noteBanner">
            <div class="carousel slide hidden-xs" id="topBanner">
                <ol class="carousel-indicators">
                    <li class="" data-target="#topBanner" data-slide-to="0"></li>
                </ol>
                <div class="carousel-inner" role="listbox">
                    <div class="item active first-slide">
                        <a :href="home.link" target="_blank" v-if="home.link&&home.link.length>0">
                            <img alt="" :src="home.bannerUrl">
                        </a>
                        <img v-else alt="" :src="home.bannerUrl">
                        <div class="carousel-desc f-dn">
                            <h3>精选游记</h3>
                            <p>听他们诉说旅程中的精彩瞬间，回味皇家加勒比游轮的超凡品质</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="container">
            <div class="row">
                <div class="col-md-12" id="reviewList">
                    <div class="filter--container">
                        <div class="filter--container__area">
                            <div class="area__container">
                                <div class="area__district">地区</div>
                                <div class="slash"></div>
                                <div
                                    class="area__filter"
                                    v-bind:class="{active: countryName === 'n'}"
                                    @click="checkCountry('n')"
                                >全部</div>
                                <div
                                    v-for="(item, index) in countries"
                                    :key="index"
                                    class="area__filter"
                                    v-bind:class="{active: item === countryName}"
                                    @click="checkCountry(item)"
                                >{{item}}</div>
                            </div>
                        </div>
                        <div class="filter--container__ship">
                            <div class="ship__container">
                                <div class="ship__district">游轮</div>
                                <div class="slash"></div>
                                <div
                                    class="ship__filter"
                                    v-bind:class="{active: shipName === 'n'}"
                                    @click="checkShip('n')"
                                >全部</div>
                                <div
                                    v-for="(item, index) in ships"
                                    :key="index"
                                    class="ship__filter"
                                    v-bind:class="{active: item === shipName}"
                                    @click="checkShip(item)"
                                >{{item}}</div>
                            </div>
                        </div>
                        <div class="filter--container__sort">
                            <div class="sort__container" v-bind:class="{arrowUp: orderBy === 1}" @click="changeSailDate">
                                <img v-if="orderBy === 0 || orderBy === 1" class="orderImg timeOrder" src="../../assets/blue_arrow.png" alt="">
                                <img v-else class="orderImg timeOrder" src="../../assets/gray_arrow.png" alt="">
                                <span>出行时间</span>
                            </div>
                            <div class="sort__container" v-bind:class="{arrowUp: orderBy === 6}" @click="changeCreateTime">
                                <img v-if="orderBy === 5 || orderBy === 6" class="orderImg defaultOrder" src="../../assets/blue_arrow.png" alt="">
                                <img v-else class="orderImg defaultOrder" src="../../assets/gray_arrow.png" alt="">
                                <span>发布时间</span>
                            </div>
                            <div class="sort__container" v-bind:class="{arrowUp: orderBy === 11}" @click="changeUpVote">
                                <img v-if="orderBy === 10 || orderBy === 11" class="orderImg upvoteOrder" src="../../assets/blue_arrow.png" alt="">
                                <img v-else class="orderImg upvoteOrder" src="../../assets/gray_arrow.png" alt="">
                                <span>点赞数</span>
                            </div>
                        </div>
                    </div>
                    <div class="noteList--container">
                        <div v-for="(item, itemIndex) in list" :key="item.id" class="notes--container col-sm-4">
                            <router-link :to="`/Rccl.Review/Travel/d-${countryName}-${shipName}-${orderBy}-${offset + itemIndex}-${item.id}.html`">
                                <div class="inner--container">
                                    <div class="bannerImg">
                                        <img :src="item.iconImage" :alt="item.title">
                                        <span class="notes_title">{{item.title}}</span>
                                    </div>
                                    <div class="tag--container">
                                        <div v-for="(tag, index) in item.tags.split(',')" :key="index" class="tag">{{tag}}</div>
                                        <div class="praiseCon">
                                            <p class="praiseTxt">
                                                <img src="https://resource.rcclchina.com.cn/Review/page/%E6%B8%B8%E8%AE%B0%E7%82%B9%E8%B5%9E%E5%9B%BE%E6%A0%87.png" class="praisePicBtn_title">
                                                <span class="praiseNumber">{{item.score}}</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="cruiseInfo--container">
                                        <span class="cruiseSpot">{{item.route}}</span>
                                        <span class="noteDate">{{item.sailDate.split('-').join('.')}}</span>
                                    </div>
                                    <div class="bottom--container">
                                        <div class="userInfo--container">
                                            <div class="avatar">
                                                <img v-if="item.authorHeadImg" :src="item.authorHeadImg" alt="">
                                                <img v-else src="https://resource.rcclchina.com.cn/logo/PC/logoAvatarCircleBlueLarge.png" alt="">
                                            </div>
                                            <div class="userName">{{item.author}}</div>
                                        </div>
                                        <div class="shipName">{{item.shipName}}</div>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 页码 -->
            <section class="pagination-container">
                <pagination
                        :size="pageSize"
                        :current="pageIndex"
                        :total="total"
                        placement="center"
                        @on-change="handleChangePage"
                ></pagination>
            </section>

            <!-- 视频 -->
            <div class="video">
                <video :poster="home.videoImgUrl" :src="home.videoUrl" controls></video>
            </div>
        </section>
    </div>
</template>

<script>
    import api from '@/api'
    import Pagination from './Pagination'

    export default {
        name: 'TravelNotesList',
        components: {
            Pagination,
        },
        data: () => {
            return {
                token: '',
                home: {},
                list: [],
                countries: [],
                ships: [],
                pageIndex: 1,
                offset: 0,
                pageSize: 9,
                total: 0,
                countryName: 'n',
                shipName: 'n',
                orderBy: 0, //排序 0 默认(出航时间)  1默认的倒序  5发布时间  6发布时间的倒叙   10点赞数  11点赞数的倒叙
            }
        },
        beforeMount () {
            this.init()
        },
        methods: {
            async init () {
                const params = this.$route.params
                this.countryName = params.countryName
                this.shipName = params.shipName
                this.orderBy = parseInt(params.orderBy)
                this.offset = parseInt(params.offset)
                this.pageIndex = this.offset / this.pageSize + 1

                await this.initPage()
            },
            async initPage () {
                this.token = this.$store.state.user.userToken
                const data = await this.getTravelNotes()

                //初始化数据
                this.home = data.home
                this.list = data.reviewArticleViews
                this.countries = data.countries
                this.ships = data.ships
                this.total = data.count
            },
            async checkCountry (country) {
                this.countryName = country
                await this.refresh({ countryName: country })
            },
            async checkShip (ship) {
                this.shipName = ship
                await this.refresh({ shipName: ship })
            },
            async changeSailDate () {
                if (this.orderBy === 0) this.orderBy = 1
                else this.orderBy = 0
                await this.refresh({ orderBy: this.orderBy })
            },
            async changeCreateTime () {
                if (this.orderBy === 5) this.orderBy = 6
                else this.orderBy = 5
                await this.refresh({ orderBy: this.orderBy })
            },
            async changeUpVote () {
                if (this.orderBy === 10) this.orderBy = 11
                else this.orderBy = 10
                await this.refresh({ orderBy: this.orderBy })
            },
            async handleChangePage (page) {
                this.pageIndex = page
                this.offset = (page - 1) * this.pageSize
                await this.refresh({ offset: this.offset }, 'page')
            },
            async refresh (params, key) {
                if (key === 'page') {
                    this.$router.push({ params })
                } else {
                    this.pageIndex = 1
                    this.offset = 0
                    this.$router.push({
                        params: {
                            ...params,
                            offset: 0
                        }
                    })
                }
                await this.initPage()
            },
            async getTravelNotes () {
                this.$loading.show()
                const {success, data, errMsg} = await api.review.getTravelNotes({
                    userName: this.token,
                    offset: this.offset,
                    limit: this.pageSize,
                    shipName: this.shipName,
                    countryName: this.countryName,
                    orderBy: this.orderBy,
                })
                this.$loading.hide()
                if (!success) {
                    this.$alert.show(errMsg)
                } else {
                    return data
                }
            },
        }
    }
</script>

<style lang="less" scoped>
    .noteBanner {
        position: relative;
        width: 100%;
        text-align: center;
        .carousel-desc {
            position: absolute;
            width: 100%;
            top: 80px;
            text-align: center;
            color: #fff;
        }
    }
    .video {
        margin: 20px auto 0;
        width: 100%;
        video {
            width: 100%;
        }
    }
    .pagination-container {
        padding: 20px 0;
    }
    .filter--container {
        width: 100%;
        background-color: #fff;
        margin-top: 20px;
        min-width: 768px;
        padding: 22px 20px 18px 20px;
        border-radius: 3px;
        box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
        -webkit-tap-highlight-color: transparent;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        user-select: none;
        -webkit-appearance: none;
        .filter--container__area,
        .filter--container__ship {
            position: relative;
            margin-bottom: 25px;
            .area__container,
            .ship__container {
                position: relative;
                padding: 0 70px 15px 0;
                border-bottom: dotted 1px #eee;
                .area__district,
                .ship__district {
                    display: inline-block;
                    color: #101E53;
                    font-weight: 600;
                }
                .area__filter,
                .ship__filter {
                    display: inline-block;
                    margin: 0 8px;
                    padding: 6px 14px;
                    border-radius: 4px;
                    cursor: pointer;
                    &:hover {
                        background-color: #ededed;
                    }
                    &.active {
                        color: #fff;
                        background-color: #4A73B4;
                    }
                }
                .slash {
                    display: inline-block;
                    margin: 0 10px 0 18px;
                    width: 1px;
                    height: 16px;
                    background-color: #ccc;
                    vertical-align: middle;
                }
            }
        }
        .filter--container__sort {
            .sort__container {
                display: inline-block;
                margin: 0 15px;
                cursor: pointer;
                img {
                    margin-right: 3px;
                }
            }
        }

    }

    .noteList--container {
        margin-top: 20px;
        margin-left: -5px;
        margin-right: -5px;
        .notes--container {
            cursor: pointer;
            padding: 0;
            .inner--container {
                position: relative;
                margin-left: 5px;
                margin-right: 5px;
                margin-bottom: 10px;
                overflow: hidden;
            }
            a:hover {
                text-decoration: none;
            }
            .bannerImg {
                position: relative;
                width: 100%;
                height: 247px;
                overflow: hidden;
                border-top-right-radius: 5px;
                border-top-left-radius: 5px;
                .notes_title {
                    position: absolute;
                    bottom: 20px;
                    display: block;
                    padding: 13px 10px;
                    height: 45px;
                    width: 100%;
                    color: #fff;
                    background: rgba(0,0,0,.50);
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                img {
                    width: 100%;
                }
            }
            .tag--container {
                position: relative;
                padding: 15px;
                background-color: #fff;
                overflow:hidden;
                .tag {
                    display: inline-block;
                    margin: 0 8px 0 0;
                    padding: 4px 10px;
                    font-size: 12px;
                    color: #777;
                    background-color: #eee;
                    border-radius: 10px;
                }
            }
            .cruiseInfo--container {
                position: relative;
                height: 45px;
                padding-left: 20px;
                padding-right: 20px;
                padding-bottom: 20px;
                border-bottom: dotted 1px #ccc;
                background-color: #fff;
                .cruiseSpot {
                    color: #000;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 195px;
                    display: inline-block;
                }
                .noteDate {
                    color: #777;
                    float: right;
                }
            }
            .bottom--container {
                padding: 20px;
                border-bottom-left-radius: 5px;
                border-bottom-right-radius: 5px;
                background-color: #fff;
                overflow: hidden;
                .userInfo--container {
                    display: inline-block;
                    .avatar {
                        width: 43px;
                        height: 43px;
                        display: inline-block;
                        border-radius: 50%;
                        vertical-align: middle;
                        overflow: hidden;
                        img {
                            width: 100%;
                        }
                    }
                    .userName {
                        display: inline-block;
                        padding-left: 10px;
                        color: #777;
                    }
                }
                .shipName {
                    display: inline-block;
                    padding-top: 10px;
                    float: right;
                    color: #4A73B4;
                }
            }
        }
    }


    /*************cruise_detail__recommend*************/
    .personalCenter__recommend .or_line_con {
        width: 1150px;
    }

    /* 点赞 */
    .praiseCon {
        display: inline-block;
        font-size: 12px;
        float:right;
    }
    .praiseTxt {
        font-size:16px;
        color:#000;
        display:inline-block;
        img {
            margin-right: 3px;
        }
        img, span {
            display: inline-block;
            vertical-align: middle;
        }
    }
    .praisePicBtn {
        width:40px;
        height:40px;
    }
    /*主页Banner 上的文字*/
    .noteBanner .carousel-desc h3{
        font-size:32px;
    }
    .noteBanner .carousel-desc p{
        font-size:16px;
    }
    /*游记列表底部加入半透明*/
    .noteList--container .notes--container .bannerImg .notes_shadow{
        position:absolute;
        bottom:20px;
        left:0;
        display:inline-block;
        width:100%;
        height:45px;
        background:rgba(0,0,0,.14);
    }
    /*游记标题页面点赞模块*/
    .praisePicBtn_title{
        width:36px;
        height:36px;
    }

    /*新增排序*/
    .arrowUp img
    {
        transform:rotate(180deg);
        -ms-transform:rotate(180deg); /* Internet Explorer */
        -moz-transform:rotate(180deg); /* Firefox */
        -webkit-transform:rotate(180deg); /* Safari 和 Chrome */
        -o-transform:rotate(180deg); /* Opera */
    }
</style>
